import React from 'react';
import { MDBAccordion, MDBAccordionItem, MDBContainer } from 'mdb-react-ui-kit';

const FAQ = () => {
  return (
    <section id='faq' className='bg-white'>
      <div className='s-20'></div>
      <div className='container tc'>
        <div className='s-40'></div>
        <h3 className='title-sub dark w-80 ma'>F.A.Q</h3>
      </div>
      <div className='container'>
        <div className='w-80 m-100 ma'>
          <MDBContainer>
            <MDBAccordion alwaysOpen initialActive={1}>
              <MDBAccordionItem
                collapseId={1}
                headerTitle='1. Які ви тримаете гарантії?'
                className='title-mini fw-400'
              >
                Ми гарантуемо тобі 100% працевлаштування, за нашим договором.
                Усі умови прописані в договорі-офері на нашому сайті.
              </MDBAccordionItem>
              <MDBAccordionItem
                collapseId={2}
                headerTitle='2. Чи повинен я бути ФОП-ом?'
                className='title-mini fw-400'
              >
                Так, згідно з умовами договору-оферу, треба бути ФОП-ом третьої групи.
              </MDBAccordionItem>
              <MDBAccordionItem
                collapseId={3}
                headerTitle='3. Чому я повинен платити 150 грн?'
                className='title-mini fw-400'
              >
                Це сервісний збір, який ми беремо один раз за нашу операційну роботу.
                Він не включається в оплату послуг та не підлягає поверненню.
              </MDBAccordionItem>
              <MDBAccordionItem
                collapseId={4}
                headerTitle='4. Чи вся підготовка проходить онлайн?'
                className='title-mini fw-400'
              >
                Так, всі консультації проходять онлайн у зручний для вас час.
              </MDBAccordionItem>
              <MDBAccordionItem
                collapseId={5}
                headerTitle='5. З якими країнами ви працюєте?'
                className='title-mini fw-400'
              >
                На даний момент працюемо виключно з Україною.
              </MDBAccordionItem>
              <MDBAccordionItem
                collapseId={6}
                headerTitle='6. У який час проходять консультації та заняття?'
                className='title-mini fw-400'
              >
                Ми працюемо в робочий час, з 10:00 до 18:00 по Києву.
                Субота та неділя - вихідні.
              </MDBAccordionItem>
              <MDBAccordionItem
                collapseId={7}
                headerTitle=' 7. Чи можу я відмовитися від оффера, якщо він не підходить?'
                className='title-mini fw-400'
              >
                Так, згідно з умовами договору-оферу, можна відмовитися від оффера.
              </MDBAccordionItem>
            </MDBAccordion>
          </MDBContainer>
        </div>
      </div>
      <div className='s-100'></div>
    </section>
  );
};
export { FAQ };
